<div class="loader" *ngIf="routeLazyLoading">
    <div class="loader-value"></div>
</div>
<router-outlet></router-outlet>
